import { initialize, LDClient, LDFlagChangeset, LDFlagValue, LDUser } from 'ldclient-js';

export interface ILaunchDarklySessionParams {
  uuid: string;
  full_name: string;
  first_name: string;
  last_name: string;
  email: string;
  entity: {
    id: string;
  };
  role: {
    name: string;
  };
}

export type ILaunchDarklyParams = { session: ILaunchDarklySessionParams; currentEntityId: string };

export const LAUNCH_DARKLY_CONTEXT_KEY = 'financial-reporting';

let client: LDClient = null;

export const sessionToLDUser = (params: ILaunchDarklyParams): LDUser => {
  const { session, currentEntityId } = params;

  return {
    key: LAUNCH_DARKLY_CONTEXT_KEY,
    name: session.full_name,
    firstName: session.first_name,
    lastName: session.last_name,
    email: session.email,
    custom: {
      userEntityId: session.entity.id,
      selectedEntityId: currentEntityId,
      role: session.role.name
    }
  };
};

export const ldInitialize =
  (
    isLdAvailable: boolean,
    ldEnvKey: string,
    changeHandler: (current?: LDFlagValue | LDFlagChangeset, previous?: LDFlagValue) => void
  ) =>
  async (session: ILaunchDarklyParams): Promise<LDClient> => {
    if (!isLdAvailable) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('feature flag provider unavailable');
      }

      return Promise.reject(null);
    }

    if (client) {
      return client.waitUntilReady().then(() => client);
    }

    client = initialize(ldEnvKey, sessionToLDUser(session));
    client.on('change', changeHandler);

    return client.waitUntilReady().then(() => client);
  };
